
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import './PoliciesProcedures.css';

const PoliciesProceduresMain = () => {
    return (
        <div className="pp-page-wrapper">
            <div className="pp-container">
                <h1 className="pp-title">Policies & Procedures</h1>
                <div className="pp-grid">
                    <Link to="/policies" className="pp-card">
                        <div className="pp-card-icon">
                            <FontAwesomeIcon icon={faFileAlt} />
                        </div>
                        <h2>Policies</h2>
                        <p>Review our company policies, code of conduct, and organizational guidelines.</p>
                    </Link>

                    <Link to="/procedures" className="pp-card">
                        <div className="pp-card-icon">
                            <FontAwesomeIcon icon={faClipboardList} />
                        </div>
                        <h2>Procedures</h2>
                        <p>Step-by-step guides and standard operating procedures for various tasks.</p>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PoliciesProceduresMain;
